import React from 'react';

export const ExposureCategoriesLink = (
  <p>
    <va-link
      href="https://www.publichealth.va.gov/exposures/index.asp"
      text="Find more military exposure categories on our Public Health website"
      external
    />
  </p>
);

export const OtherExposureDescription = (
  <>
    <p>
      We want to know about any other toxins or other hazards you think you may
      have been exposed to while deployed or during training or active duty
      service.
    </p>
    {ExposureCategoriesLink}
    <p>
      <strong>Note:</strong> If you’re not sure, you can still select any of the
      toxins or hazards listed here. This may help us find information about
      your service history and confirm whether you may have been exposed to any
      toxins or other hazards.
    </p>
  </>
);
